import { styled, Box, Slider } from "@mui/material";

const BackgroundMediaRoot = styled(Box)(() => ({ 
  position: "absolute", 
  width:"100%",
  height:"100%",
  top: 0,
  left: 0,
  margin:"auto",
}));

export { BackgroundMediaRoot };
